import api from './api';

export interface InvoiceBranding {
  id: number;
  logoBase64: string | null;
  companyName: string;
  companyTagline: string | null;
  companyAddress: string;
  gstNumber: string | null;
  contactNumber: string;
  email: string;
  website: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertInvoiceBrandingPayload {
  logoBase64?: string | null;
  companyName: string;
  companyTagline?: string | null;
  companyAddress: string;
  gstNumber?: string | null;
  contactNumber: string;
  email: string;
  website?: string | null;
}

// Invoice branding is part of the Billing module — served under /billing/branding.
export const invoiceBrandingService = {
  // Returns null when the tenant has not configured branding yet.
  getBranding: async (): Promise<InvoiceBranding | null> => {
    const response = await api.get('/billing/branding');
    return (response as any).data;
  },

  saveBranding: async (payload: UpsertInvoiceBrandingPayload): Promise<InvoiceBranding> => {
    const response = await api.put('/billing/branding', payload);
    return (response as any).data;
  },
};
